/*=============================================== Homepage ===============================================*/

import { Text, CodeContainer, Section } from "tsx-library-julseb"

import { Page } from "components"

import { siteData } from "data"

const Homepage = () => {
    return (
        <Page title="Homepage">
            <Text tag="h1">{siteData.name}</Text>

            <Section gap="xs">
                <Text tag="h2">Install</Text>
                <CodeContainer language="shell">
                    {siteData.npmLib}
                </CodeContainer>
            </Section>

            <Section gap="xs">
                <Text tag="h2">Import CSS file</Text>

                <Text>
                    Open your <code>index.js</code> file, and import this file
                    on top of the page:
                </Text>
                <CodeContainer language="javascript">
                    {siteData.linkCss}
                </CodeContainer>
            </Section>
        </Page>
    )
}

export default Homepage
